module.exports = __webpack_public_path__ + "static/media/shaff1172.29f02ce7.jpg";